var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 3.009A3.005 3.005 0 0 1 3.003 0h7.994A3.01 3.01 0 0 1 14 3.009V7.49a3.01 3.01 0 0 1-3.01 3.009H7l-3.5 3H3v-3h-.009C1.34 10.5 0 9.149 0 7.491z"
})));
export default SvgFacebookMobileComment;